const SMS_RETRY_DETAIL_FRAGMENT = 'Не прошло время, после которого доступна повторная попытка'

export function getAuthErrorDetail(data) {
  if (!data) {
    return ''
  }

  const {detail, phone} = data

  if (Array.isArray(detail)) {
    return detail.filter(Boolean).join(' ')
  }

  if (typeof detail === 'string') {
    return detail
  }

  if (typeof phone === 'string') {
    return phone
  }

  if (Array.isArray(phone)) {
    return phone.filter(Boolean).join(' ')
  }

  return ''
}

export function getAuthErrorCode(data) {
  return typeof data?.code === 'string' ? data.code : null
}

export function getAuthErrorMessage(error) {
  return getAuthErrorDetail(error?.response?.data)
}

export function isAuthRateLimitError(error) {
  const status = error?.response?.status
  const detail = getAuthErrorMessage(error)

  if (status === 429) {
    return true
  }

  return status === 400 && detail.includes(SMS_RETRY_DETAIL_FRAGMENT)
}

export function getRetryAfterMs(error) {
  const headers = error?.response?.headers || {}
  const raw = headers['retry-after'] ?? headers['Retry-After']

  if (raw == null || raw === '') {
    return null
  }

  const asSeconds = Number(raw)
  if (Number.isFinite(asSeconds)) {
    return Math.max(0, Math.round(asSeconds * 1000))
  }

  const asDate = Date.parse(raw)
  if (!Number.isNaN(asDate)) {
    return Math.max(0, asDate - Date.now())
  }

  return null
}

export function resolveRegisterPhone(data, formPhone) {
  return data?.phone || formPhone || ''
}

/**
 * Defensive: POST /register/ may return 200 + state (pending recovery)
 * without the classic `{ phone }` payload. Form is still open on backend.
 * Any successful response without an auth token means "continue with OTP".
 */
export function shouldOpenRegisterCodeStep(data) {
  return Boolean(data) && !data.token
}
